import type { ReactNode } from 'react'

import { NoContentFallback } from './split-view-fallbacks.atom'
import { SplitViewWrapper } from './split-view-wrapper.atom'

export interface SplitViewNoContentProps {
  onClose: () => void
  isCloseButtonHidden?: boolean
  className?: string
}

export const SplitViewNoContent: React.FC<SplitViewNoContentProps> = ({
  onClose,
  isCloseButtonHidden = false,
  className,
}): ReactNode => (
  <SplitViewWrapper
    title="Details"
    onClose={onClose}
    isCloseButtonHidden={isCloseButtonHidden}
    className={className}
  >
    <NoContentFallback />
  </SplitViewWrapper>
)
